import React, { useEffect, useState } from "react";
import {
  getAllSpeakers,
  createSpeaker,
  updateSpeaker,
  deleteSpeaker,
  activateSpeaker,
  deactivateSpeaker,
} from "../services/adminSpeakerServices";

const AdminSpeakerPage = () => {
  const [speakers, setSpeakers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const [editingSpeaker, setEditingSpeaker] = useState(null);

  const emptyForm = { name: "", bio: "", active: true };
  const [form, setForm] = useState(emptyForm);

  const loadSpeakers = async () => {
    setLoading(true);
    try {
      const res = await getAllSpeakers();
      setSpeakers(res.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadSpeakers();
  }, []);

  const openAddModal = () => {
    setEditingSpeaker(null);
    setForm(emptyForm);
    setOpenModal(true);
  };

  const openEditModal = (speaker) => {
    setEditingSpeaker(speaker);
    setForm(speaker);
    setOpenModal(true);
  };

  const handleSave = async () => {
    if (editingSpeaker) {
      await updateSpeaker(editingSpeaker.id, form);
    } else {
      await createSpeaker(form);
    }
    setOpenModal(false);
    loadSpeakers();
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this speaker?")) {
      await deleteSpeaker(id);
      loadSpeakers();
    }
  };

  const toggleStatus = async (speaker) => {
    if (speaker.active) {
      await deactivateSpeaker(speaker.id);
    } else {
      await activateSpeaker(speaker.id);
    }
    loadSpeakers();
  };

  const filtered = speakers.filter((s) =>
    s.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">Speakers</h1>
        <button
          className="bg-blue-600 text-black px-4 py-2 rounded"
          onClick={openAddModal}
        >
          + Add Speaker
        </button>
      </div>

      <input
        placeholder="Search speaker..."
        className="border p-2 rounded w-full mb-4"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {loading ? (
        <p>Loading...</p>
      ) : (
        <table className="w-full border">
          <thead className="bg-gray-100">
            <tr>
              <th className="p-2">Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((s) => (
              <tr key={s.id} className="border-t">
                <td className="p-2">{s.name}</td>
                <td>
                  <span
                    className={`px-2 py-1 rounded text-sm ${
                      s.active ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"
                    }`}
                  >
                    {s.active ? "ACTIVE" : "INACTIVE"}
                  </span>
                </td>
                <td className="space-x-4">
                  <button
                    className="text-blue-600"
                    onClick={() => openEditModal(s)}
                  >
                    Edit
                  </button>
                  <button
                    className="text-yellow-600"
                    onClick={() => toggleStatus(s)}
                  >
                    {s.active ? "Deactivate" : "Activate"}
                  </button>
                  <button
                    className="text-red-600"
                    onClick={() => handleDelete(s.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {openModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center">
          <div className="bg-white p-6 rounded w-96">
            <h2 className="font-bold mb-4">
              {editingSpeaker ? "Edit Speaker" : "Add Speaker"}
            </h2>

            <input
              className="border p-2 w-full mb-2"
              placeholder="Name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
            />

            <textarea
              className="border p-2 w-full mb-2"
              placeholder="Bio"
              value={form.bio || ""}
              onChange={(e) => setForm({ ...form, bio: e.target.value })}
            />

            <div className="flex justify-end space-x-2">
              <button
                className="px-4 py-2"
                onClick={() => setOpenModal(false)}
              >
                Cancel
              </button>
              <button
                className="bg-blue-600 text-black px-4 py-2 rounded"
                onClick={handleSave}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminSpeakerPage;
